import { ApolloLink } from "@apollo/client";
import moment from "moment";
import { logger, HttpColumns } from "@mwt/web-js-telemetry";

import { DataBagHttpColumns, EventType } from "@smb/web-telemetry";
import { getTelemetrySessionId } from "../../shared/telemetry/utils/getTelemetrySessionId";

let correlationId = 0;
/**
 * Logs response time and data error to telemetry.
 */
export const telemetryLink = new ApolloLink((operation, forward) => {
  const { operationName } = operation;
  const eventStartTime = moment();
  const context = operation.getContext();

  operation.setContext({ eventStartTime });
  operation.setContext({
    headers: {
      ...context?.headers,
      "x-ms-correlationid": `${getTelemetrySessionId()}.${++correlationId}`,
    },
  });

  if (!forward) {
    return null;
  }

  return forward(operation).map((response) => {
    const endTime = moment();
    const context = operation.getContext();

    const requestEventStartTime = context?.eventStartTime;
    const elasedTime = moment
      .duration(endTime.diff(requestEventStartTime))
      .asMilliseconds();

    const responseObject = context?.response;
    const requestHeaders = context?.headers;
    const correlationId = requestHeaders?.["x-ms-correlationid"];
    const contentLength = responseObject?.headers?.get("content-length");
    const resultCode = responseObject?.status;
    const isSuccessful = resultCode >= 100 && resultCode < 400 ? true : false;
    const url = responseObject?.url || "";

    logger.logHttpRequestEvent(
      {
        [HttpColumns.Hostname]: window.location.hostname,
        [HttpColumns.Duration]: elasedTime,
        [HttpColumns.ResultCode]: resultCode,
        [HttpColumns.ContentLength]: contentLength,
        [HttpColumns.RequestCreatedTime]: requestEventStartTime?.utc().format(),
        databag: {
          [DataBagHttpColumns.DataBagIsSuccessful]: isSuccessful,
          [DataBagHttpColumns.DataBagCorrelationId]: correlationId,
          [DataBagHttpColumns.DataBagUrl]: operationName,
          [DataBagHttpColumns.DataBagServiceUrl]: url,
        },
      },
      EventType.NonUiEvent
    );

    return response;
  });
});
